import Anchor from './anchor'

export default Anchor


// WEBPACK FOOTER //
// ./src/components/fields/anchor/index.js